import type { AccountType } from '~/services/UsersService';

export const ACCOUNT_TYPE = {
  GUEST: 'guest',
  USER: 'user',
  SERVICE: 'service',
} as const satisfies Record<string, AccountType>;

export const ACCOUNT_TYPE_LABELS: Record<AccountType, string> = {
  [ACCOUNT_TYPE.GUEST]: 'Guest',
  [ACCOUNT_TYPE.USER]: 'User',
  [ACCOUNT_TYPE.SERVICE]: 'Service',
};

// Accounts can only be switched between these types. Guest accounts can't be
// changed, and no account can be changed into a guest.
export const CHANGEABLE_ACCOUNT_TYPES: Array<AccountType> = [ACCOUNT_TYPE.USER, ACCOUNT_TYPE.SERVICE];

// Only ENABLED is meaningful to the admin portal; any other status is treated as disabled.
export const ACCOUNT_STATUS = {
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED',
} as const;
